// @flow
export const CopyRight = "Copyright ©️" + new Date().getFullYear() + ", by Imagus Technology Pty Ltd. All Rights Reserved.";


// WEBPACK FOOTER //
// ./src/conference/containers/CopyRight.js